import React, { Component } from 'react';
import '../Css/Style.css';
import { getData,deleteData } from '../Api/Config';
import { Link } from 'react-router-dom';
import CirclePreloader from '../layouts/CirclePreloader'
// import Delete from '../layouts/DeleteModal';

class Detail extends Component{
  state = {
      app:null,
      isloader:false
  }
    componentDidMount(){
        this.GetData();
    
    }

GetData= async ()=>{
    this.setState({isloader:true});
    const ID = this.props.match.params.id;
   const data = await getData(`apps/${ID}`).then(res=> res).catch(err=>err);
    if(data)
        this.setState({isloader:false});
        this.setState({app:data});
        
}

handleDelete=Id=>{
    this.setState({isloader:true});
    // console.log(Id);  
    deleteData("apps",Id).then(res=>{
        this.setState({isloader:false});
        
    }).then(()=>{
        this.props.history.push('/admin/AppDetails');
    }).catch(err=>{
        this.setState({isloader:false});
        console.log(err);
    })
  }

    render(){
        let mystyle = this.state.isloader?{
            visibility: 'hidden'
            }:{
              visibility: 'visible'
            }
     const publisherId = this.props.match.params.pub;   
        return(
    
            <div>
             {this.state.isloader?<CirclePreloader/>:null}
                <div className="card" style={mystyle}>
                        <div className="card-panel blue-grey white-text"><Link to="/admin/AppDetails" style={{color:'white'}}> <i className="tiny material-icons">arrow_back</i> <span> App details</span></Link></div>
                        <div className="row card-content" >
                        <div className="col l12 m12 s12">
                        
                       <div className="col s6 l4">
                       <img alt={this.state.app && this.state.app.id}  src={this.state.app && this.state.app.logoUrl} style={{width:'200px',height:'200px'}}/>
                      <div className="row"  style={{inlineSize: 'max-content',marginLeft:1}}>                       
                      <Link to={`/admin/EditApp/${this.state.app && this.state.app.id}/${publisherId}`}><button className="btn waves-effect waves-light buttonmargin green " type="submit" name="action">Edit
                        <i className="material-icons right">edit</i></button></Link>
                        {/* <button data-target={this.state.app && this.state.app.id} className="btn waves-effect waves-light buttonmargin red button1 modal-trigger" type="submit" name="action">
                          Delete <i className="material-icons right">delete</i>
                    </button> */}
                    </div>
                    {/* <Delete id={this.state.app && this.state.app.id} history={this.props.history} handleDelete={()=>this.handleDelete(this.state.app && this.state.app.id)}/> */}
                       </div>
                       <div className="col s12 l8 pull-l1">
                       <ul className="collection with-header app-info">
                            <li className="collection-header">Name:<h6>{this.state.app && this.state.app.name}</h6></li>
                            <li className="collection-item">id: {this.state.app && this.state.app.id}</li>
                            <li className="collection-item">Package: {this.state.app && this.state.app.appId}</li>
                            <li className="collection-item">platform: {this.state.app && this.state.app.platform}</li>
                            <li className="collection-item">status: {this.state.app && this.state.app.status}</li>
                        </ul>
                       </div>
                       </div>
                       </div>
                </div>
            </div>
           
        )
    }
}
export default Detail;